import { call, put, takeEvery } from 'redux-saga/effects'

import store from '../store';
import { logError } from 'shared-services/logger-service';

export const createSaga = ({
    type,
    fn,
    args = () => [],
    successPayload = result => result,
    errorPayload = e => ({ message: e.message || e }),
    progressPayload = progress => progress,
    progress
}) => {
    function* saga(action) {
        if (action.preventSave) {
            action.onComplete?.();
            return;
        }

        const handleProgress = (loaded, total) => {
            store.dispatch({
                type: `${type}_PROGRESS`,
                payload: progressPayload(loaded / total, action)
            });
        }

        try {
            const result = yield call(fn, ...args(action), progress && handleProgress);
            yield put({
                type: `${type}_SUCCEEDED`,
                payload: successPayload(result, action)
            });

            action.onComplete?.(result);
            return result
        } catch (e) {
            yield put({
                type: `${type}_FAILED`,
                payload: errorPayload(e, action)
            });

            logError('saga', e, { action });
            action.onError?.(e);
            return e;
        }
    }

    return function* watcher() {
        yield takeEvery(`${type}_REQUESTED`, saga);
    };
}
